var typography = {
  h01: 'normal normal 800 20px / 150% NanumSquareOTF',
  h02: 'normal normal 700 18px / 100% NanumSquareOTF_ac',
  title01: 'normal normal 800 17px / 140% NanumSquareOTF',
  title02: 'normal normal 400 17px / 100% NanumSquareOTF',
  title03: 'normal normal 700 15px / 100% NanumSquareOTF_ac',
  body01m: 'normal normal 500 15px / 100% Noto Sans CJK KR',
  body01r: 'normal normal 400 15px / 100% Noto Sans CJK KR',
  body02m: 'normal normal 500 13px / 150% Noto Sans CJK KR',
  body02r: 'normal normal 400 13px / 150% Noto Sans CJK KR',
  body03m: 'normal normal 500 12px / 100% Noto Sans CJK KR',
  body03r: 'normal normal 400 12px / 100% Noto Sans CJK KR'
};

export { typography };
